import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  empleadoList,
  empleadoCreate,
  empleadoRead,
  empleadoUpdate,
  empleadoDelete,
} = actions;

const empleadoListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/empleado/list.php?paramBusqueda=' + paramBusqueda);
      if (response.status === 200 && response.data.data) {
        dispatch(empleadoList(response.data.data));
        return true;
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const empleadoCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/empleado/manage.php', data);
      if (response.status === 200)
        return true
      else
        return false
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const empleadoReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/empleado/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(empleadoRead(response.data.data));
          return true;
        }
      } else {
        dispatch(empleadoRead({}));
      }

      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const empleadoConfigurarComisionAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/empleado/manage.php', data);
      if (response.status === 200)
        return true
      else
        return false
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

export {
  empleadoListAction,
  empleadoCreateAction,
  empleadoReadAction,
  empleadoConfigurarComisionAction
};
